import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Layout, UserNavbar } from '../../../../components';
import SimpleCard from '../../../../components/SimpleCard';
import { APP_ROUTES } from '../../../../constants/app-routes';
import TabDashboard from './components/TabDashboard/TabDashboard';

export default function AdminDashboard() {
  const [tabs] = useState([
    { id: 1, name: 'Events', route: APP_ROUTES.EVENTS_ADMIN_SEARCH },
    { id: 2, name: 'Transactions', route: APP_ROUTES.TRANSACTIONS },
    { id: 3, name: 'Messages', route: APP_ROUTES.INBOX },
    { id: 4, name: 'Categories', route: APP_ROUTES.CATEGORIES },
    { id: 5, name: 'Pending venues owner registration', route: APP_ROUTES.PENDING_VENUES },
    { id: 6, name: 'Registered venue owners', route: APP_ROUTES.REGISTERED_VENUES },
    { id: 7, name: 'System parameters', route: APP_ROUTES.SYSTEM_PARAMETERS },
    { id: 8, name: 'Reviews', route: APP_ROUTES.MANAGE_REVIEWS },
    { id: 10, name: 'Venue Applications', route: APP_ROUTES.VENUE_APPLICATIONS_ADMIN_SEARCH },
    { id: 9, name: 'Vendors', route: APP_ROUTES.VENDORS_ADMIN_SEARCH },
    { id: 9, name: 'Venue transactions', route: APP_ROUTES.VENUE_TRANSACTIONS },
  ]);

  const navigate = useNavigate();

  const onRedirect = (route) => {
    navigate(route);
  };

  return (
    <Layout>
      <Grid container>
        <Grid item xs={12}>
          <UserNavbar />
        </Grid>
        <Grid item xs={12} sx={{ my: 14, mx: 5 }}>
          <Typography sx={{ fontSize: 55, textAlign: 'center', mb: 4 }} variant="h1">
            Admin Dashboard
          </Typography>
          <SimpleCard>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              Quick Actions
            </Typography>
            <Grid container sx={{ display: 'flex', justifyContent: 'space-around' }}>
              {tabs.map((item) => (
                <Grid item sm={3} key={item.id}>
                  <TabDashboard title={item.name} route={item.route} onRedirect={onRedirect} />
                </Grid>
              ))}
            </Grid>
          </SimpleCard>
        </Grid>
      </Grid>
    </Layout>
  );
}
